import { render } from "./swiperSlides.vue?vue&type=template&id=02baacc0&scoped=true&ts=true"
import script from "./swiperSlides.vue?vue&type=script&lang=ts"
export * from "./swiperSlides.vue?vue&type=script&lang=ts"

import "./swiperSlides.vue?vue&type=style&index=0&id=02baacc0&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02baacc0"]])

export default __exports__